// Plan data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.

import { BillingPeriod, CountryCode, CurrencyCode, TierCode } from './subscription.model';

export interface Plan {
  code: TierCode;
  displayName: string;                  // "Foundation", "Professional", "Business"
  shortDescription: string;
  features: string[];                   // Bullet list for plan picker
  pricing: PricePoint[];                // All currency * period combinations
}

export interface PricePoint {
  currency: CurrencyCode;
  countryCode: CountryCode;
  billingPeriod: BillingPeriod;
  // Per-seat: price per seat. Flat: the flat per-business base price. Minor units.
  perSeatMinor: number;
  aiCreditsPerSeat: number;             // Premium credits per seat per month (flat: pooled per business)
  basicTurnsPerSeat: number;            // Basic-model credits per seat per month (flat: pooled per business)
  // Stage-1 NG flat pricing. Absent/undefined on older payloads => 'per_seat'.
  pricingModel?: 'per_seat' | 'flat';
  includedSeats?: number | null;        // Flat only: seats bundled into the flat price
  extraSeatMonthlyMinor?: number | null; // Flat only: monthly extra-seat price, minor units
  stripePriceId: string | null;         // Populated post-backend-impl
}
